'use client';

import { useTranslations } from 'next-intl';
import { GlowIcon, GlowTextBody, GlowTextList, Icons } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';
import { RichText } from '../../../../client';

type SearchSuggestionsErrorProps = {
    searchInput: string;
};

export const SearchSuggestionsError: Component<SearchSuggestionsErrorProps> = ({ searchInput }) => {
    const t = useTranslations('Header.search.label');
    const searchTips = [t('tryMoreGeneralTerms'), t('avoidAbbreviations'), t('checkSpelling')];

    return (
        <div className={'flex flex-col tablet:flex-row gap-1 desktop:gap-x-2.5'}>
            <GlowIcon Icon={Icons.ErrorSearch} type={'xxxLarge'} className={'mx-auto tablet:mx-0'} />
            <div className={'flex flex-col gap-1'}>
                <RichText
                    messageKey={'Header.search.label.noResultsFound'}
                    values={{
                        searchInput,
                    }}
                    className={'break-all'}
                />
                <div className={'flex flex-col pb-0.5'}>
                    <GlowTextBody text={t('searchTips')} />
                    <GlowTextList className={'marker:text-text-primary'} texts={searchTips} />
                </div>
            </div>
        </div>
    );
};
